export default __webpack_public_path__ + "static/media/offers-green.81c43409.svg";